import { create } from 'zustand';

// Persisted assignment of inventory item templates to HP/MP auto-pot shortcuts.
// Auto-attack will prefer these templates before any other matching consumable.
export type PotionKind = 'heal' | 'mana';

interface PotionShortcutState {
  hpTemplateId: number | null;
  mpTemplateId: number | null;
  setShortcut: (kind: PotionKind, templateId: number | null) => void;
  clearShortcut: (kind: PotionKind) => void;
}

const STORAGE_KEY = 'hero-potion-shortcuts-v1';

function load(): { hp: number | null; mp: number | null } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { hp: null, mp: null };
    const j = JSON.parse(raw) as { hp?: number | null; mp?: number | null };
    return {
      hp: typeof j.hp === 'number' ? j.hp : null,
      mp: typeof j.mp === 'number' ? j.mp : null,
    };
  } catch {
    return { hp: null, mp: null };
  }
}

function persist(hp: number | null, mp: number | null) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ hp, mp }));
  } catch {
    /* ignore */
  }
}

const initial = load();

export const usePotionShortcutStore = create<PotionShortcutState>((set) => ({
  hpTemplateId: initial.hp,
  mpTemplateId: initial.mp,
  setShortcut: (kind, templateId) => set((s) => {
    const next = {
      hpTemplateId: kind === 'heal' ? templateId : s.hpTemplateId,
      mpTemplateId: kind === 'mana' ? templateId : s.mpTemplateId,
    };
    persist(next.hpTemplateId, next.mpTemplateId);
    return next;
  }),
  clearShortcut: (kind) => set((s) => {
    const next = {
      hpTemplateId: kind === 'heal' ? null : s.hpTemplateId,
      mpTemplateId: kind === 'mana' ? null : s.mpTemplateId,
    };
    persist(next.hpTemplateId, next.mpTemplateId);
    return next;
  }),
}));
